import { useState, useRef, useEffect } from "react";
import { Swiper } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
const SwiperSlider = ({
  children,
  spaceBetween = 16,
  slidesPerView = 3,
  breakpoints = {},
  wrapperClass = "",
  prevBtnClass = "",
  nextBtnClass = "",
}) => {
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);
  useEffect(() => {
    // Once refs are available, assign them to swiper navigation
    if (swiperInstance && prevRef.current && nextRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      // Re-init navigation
      swiperInstance.navigation.destroy();
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);
  return (
    <div className={wrapperClass}>
      <button ref={prevRef} className={prevBtnClass} disabled={isAtStart}>
        &#10094;
      </button>
      <Swiper
        onSwiper={setSwiperInstance} // get swiper instance
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        breakpoints={breakpoints}
        modules={[Navigation]}
        onSlideChange={(swiper) => {
          setIsAtStart(swiper.isBeginning);
          setIsAtEnd(swiper.isEnd);
        }}
        onAfterInit={(swiper) => {
          setIsAtStart(swiper.isBeginning);
          setIsAtEnd(swiper.isEnd);
        }}
      >
        {children}
      </Swiper>
      <button ref={nextRef} className={nextBtnClass} disabled={isAtEnd}>
        &#10095;
      </button>
    </div>
  );
};
export default SwiperSlider;
